export default "__VITE_ASSET__Bj15XdBN__"